import { PropsWithChildren } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Grid, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

type GridContainerProps = {
  add?: boolean;
  edit?: boolean;
  deletebutton?: boolean;
  view?: boolean;
};

export function GridContainer({
  children,
  add,
}: PropsWithChildren<GridContainerProps>) {
  const navigateTo = useNavigate();
  return (
    <>
      <Paper elevation={3} sx={{ mt: 2, px: 2, py: 2 }}>
        <Grid container item xs={12} justifyContent={"flex-end"}>
          {!add ? (
            <></>
          ) : (
            <Button
              title="Add New"
              type="submit"
              variant="contained"
              onClick={() => navigateTo("add")}
              startIcon={<PlusOutlined />}
              sx={{ mb: 1 }}
            >
              Add New
            </Button>
          )}
        </Grid>
        <Grid sx={{ height: 400, width: "100%" }}>{children}</Grid>
      </Paper>
    </>
  );
}
